import Vue from 'vue';
import Loading from "./Loading.vue";
import MessageModal from "./MessageModal.vue";
import ConfirmModal from "./ConfirmModal.vue";


Vue.component("loading", Loading);
Vue.component("message-modal", MessageModal);
Vue.component("confirm-modal", ConfirmModal);